export function structureRedirect(_id) {
  return `
        <div>
            <div class="title-box">
                <div class="title-text"><i class="bi bi-box-arrow-up-right"></i> Weiterleitung an URL</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">URL</label>
                        <div class="col-12">
                            <input type="text" class="form-control form-control-sm" df-url>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
}
